// AI Generated
import { Component, Input, OnInit } from '@angular/core';
import { StateService } from '@uirouter/core';
import { UptimeRepoService } from '@client/app/services/api/uptime-repo/uptime-repo.service';
import { DateTimeService } from '@client/app/services/date-time/date-time.service';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';
import { MonUIRouterTransitionService } from '@monsido/services/ui-router-transition-service/ui-router-transition-service';
import { DateRangeService } from '@client/app/services/date-range/date-range.service';
import { PipeService } from '@client/app/filters/pipe-transformation.service';
import { MON_EVENTS } from '@monsido/core/constants/mon-events.constant';
import { contextTokens } from '@monsido/ng2/services/request-auxiliary/request-auxiliary.service';
import { ActiveRegionService } from '@client/app/blocks/service/active-region.service';
import { RESPONSE_TIME } from '@client/app/core/constants/response-time';
import { DEFAULTS } from '@monsido/ng2/core/constants/defaults.constant';
import { UptimeComponent } from '@client/app/forms/uptime/uptime.component';
import {
    FormUptimeScheduledDowntimesComponent,
} from '@client/app/forms/uptime/scheduled_downtimes/form-uptime-scheduled-downtimes.component';
import { IncidentListComponent } from '@client/app/pages/uptimes/uptime-show/incident-list/incident-list.component';

@Component({
    selector: 'uptime-show',
    standalone: false,
    template: `
        <page-header icon="fas fa-heartbeat"
                     header="{{'Uptime Monitoring' | translate}}"
                     subHeader="{{'Checks whether your website is responding and measures the response time of the server' | translate}}">
            <page-header-content>
                <div class="row">
                    <div class="col-48 text-right">
                        <csv-export-button clsSize="py-1_2 px-2"
                                           clsMargin="mr-1"
                                           [exports]="exports"></csv-export-button>
                        <a [uiSref]="'base.customer.domain.uptimes.index'"
                           *ngIf="checkpoints > 1"
                           [attr.aria-label]="'Return to heartbeat overview' | translate"
                           monEventTrigger="actionTrigger"
                           [monEventParams]="{action: 'heartbeat-back-to-overview-btn'}"
                           class="btn btn-border-radius btn-marine-blue mr-1"
                           translate>
                            Back to Heartbeat Overview
                        </a>
                        <button [attr.aria-label]="'Add new check' | translate"
                                *ngIf="checkpoints === 1"
                                class="btn btn-border-radius btn-secondary mr-1"
                                (click)="uptimeCreate()"
                                monEventTrigger="actionTrigger"
                                [monEventParams]="{action: 'hearbeat-new-check-btn'}"
                                translate>
                            + Add new check
                        </button>
                        <button class="btn btn-border-radius btn-secondary mr-1"
                                (click)="openScheduleDowntime()"
                                [attr.aria-label]="'Open Schedule downtime' | translate"
                                monEventTrigger="actionTrigger"
                                [monEventParams]="{action: 'heartbeat-exemption-btn'}">
                            <span translate>Exemption</span>
                            <span class="label label-new">{{ allScheduledDowntimes }}</span>
                        </button>
                        <button type="button"
                                class="btn btn-border-radius btn-secondary"
                                (click)="uptimeEdit(uptime)"
                                [attr.aria-label]="'Edit uptime' | translate">
                            <span class="fas fa-cog fa-lg font-size-1-5 text-v-middle"
                                  aria-hidden="true"></span>
                            <span class="sr-only"
                                  translate>Edit</span>
                        </button>
                    </div>
                </div>
            </page-header-content>
        </page-header>
        <div class="row">
            <div class="col-24">
                <span translate>Inspecting: </span>
                <a [href]="uptime.url"
                   target="_blank"
                   aria-describedby="linkOpensInNewTab"
                   [title]="'Go to page' | translate">
                    <span class="fas fa-external-link-alt ml-1"></span>
                    <span class="sr-only">{{ uptime.url }}</span>
                </a>
                <span class="pl-1 text-secondary-4">{{ uptime.url }}</span>
            </div>
            <div class="col-24 text-right mb-8">
                <date-picker
                        [(date)]="date"
                        [monDateFormat]="dateFormat"
                        (dateChange)="onDateChange()"
                        [options]="datePickerOptions"
                        [unRestrictedMax]="true"
                        class="inline-block"
                />
            </div>
        </div>
        <div class="card panel-monsido-card">
            <div class="card-body py-3">
                <mon-spinner [loading]="loading">
                    <div class="row align-items-stretch mb-6 px-6">
                        <div class="col col-md-8 pr-0 d-flex align-items-stretch">
                            <span class="vertical-ruler vertical-ruler-left"
                                  [ngClass]="{'btn-success': uptime.status, 'btn-danger': !uptime.status}">
                            </span>
                            <notification-text
                                    title="{{'Monitoring' | translate }}"
                                    classColor="{'btn-success': uptime.status, 'btn-danger': !uptime.status}"
                                    text="{{uptime.status ? 'ACTIVE' : 'INACTIVE' | translate}}">
                            </notification-text>
                        </div>
                        <div class="col col-md-8 pr-0 d-flex align-items-stretch">
                            <span class="vertical-ruler vertical-ruler-left"
                                  [ngClass]="{'btn-success': lastresultReport && uptime.status, 'btn-danger': !lastresultReport || !uptime.status}">
                            </span>
                            <notification-text
                                    title="{{'Current domain status' | translate }}"
                                    classColor="{'btn-success': lastresultReport && uptime.status, 'btn-danger': !lastresultReport || !uptime.status}"
                                    text="{{(!uptime.status ? 'N/A' : lastresultReport ? 'OK' : 'DOWN') | translate}}">
                            </notification-text>
                        </div>
                        <div class="col col-md-8 pr-0 d-flex align-items-stretch">
                            <span class="vertical-ruler vertical-ruler-left"
                                  [ngClass]="avgResponseTimeClass"></span>
                            <notification
                                    title="{{'Average response time' | translate }}"
                                    [digit]="avgResponseTime"
                                    unit="ms">
                            </notification>
                        </div>
                        <div class="col col-md-8 pr-0 d-flex align-items-stretch">
                            <span class="vertical-ruler vertical-ruler-left"
                                  [ngClass]="successRateClass"></span>
                            <notification
                                    title="{{'Average uptime' | translate }}"
                                    [digit]="report.success_rate"
                                    [allowDecimal]="true"
                                    unit="%">
                            </notification>
                        </div>
                        <div class="col col-md-8 pr-0 d-flex align-items-stretch">
                            <span class="vertical-ruler vertical-ruler-left"
                                  [ngClass]="{'btn-success': downtimes === 0, 'btn-danger': uptime.downtimes?.length !== 0}"></span>
                            <notification title="{{'Incidents' | translate }}"
                                          [digit]="downtimes">
                            </notification>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-48">
                            <mon-chart-line
                                    [colors]="lineChartColors"
                                    [emptyDataMessage]="'No Data available for selected time frame' | translate"
                                    [height]="340"
                                    [data]="lineChartData"
                                    [labels]="lineChartLabels"
                                    [series]="lineChartSeries"
                                    [options]="lineChartOptions"
                                    [override]="overrideDatasets">
                            </mon-chart-line>
                        </div>
                        <div class="col-48 text-center text-grey"
                             *ngIf="showApology()">
                            <p translate>
                                (A small percentage of heartbeats was affected by a technical issue in the selected
                                timeframe. We appologize for the inconvenience)
                            </p>
                        </div>
                    </div>
                </mon-spinner>
            </div>
        </div>
        <div class="card panel-monsido-card"
             [hidden]="loading">
            <div class="card-header">
                <h2 class="font-weight-300"
                    translate>Outages during the selected time-frame</h2>
            </div>
            <div class="card-body py-3">
                <div *ngIf="uptime.downtimes?.length !== 0">
                    <table-container [collection]="downtimesList"
                                     noResultMessage="{{'No incidents occurred in the selected time frame' | translate}}">
                        <table class="table table-hover">
                            <thead>
                            <tr>
                                <th class="col-sm-12 col-md-12 text-left"
                                    translate>Start time
                                </th>
                                <th class="col-sm-12 col-md-12"
                                    translate>End time
                                </th>
                                <th class="col-sm-4 col-md-4 text-right"
                                    translate>Duration
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngFor="let downtime of sortedDownTimesList.slice(0, 3)">
                                <td class="text-left text-v-middle">
                                        <span [ngbTooltip]="downtime.start_at | userDate:'L LT'"
                                              [triggers]="'focus hover'">
                                            {{ downtime.start_at | monSetMyTimezone | uptimeIncidientTime }}
                                        </span>
                                </td>
                                <td class="text-left text-v-middle">
                                        <span *ngIf="downtime.end_at"
                                              [ngbTooltip]="downtime.end_at | userDate:'L LT'"
                                              [triggers]="'focus hover'">
                                            {{ downtime.end_at | monSetMyTimezone | uptimeIncidientTime }}
                                        </span>
                                    <span *ngIf="!downtime.end_at"
                                          translate>
                                            Undetermined
                                        </span>
                                </td>
                                <td class="text-right text-v-middle">{{ duration(downtime.start_at, downtime.end_at) }}</td>
                            </tr>
                            </tbody>
                        </table>
                    </table-container>
                    <a *ngIf="sortedDownTimesList.length > 3"
                       class="btn"
                       (click)="showCheckpointList()"
                       translate>Show all</a>
                </div>
                <div *ngIf="uptime.downtimes?.length === 0"
                     class="row">
                    <div class="col-lg-48 col-sm-48 text-center outer-t text-grey">
                        <h3 translate>No outages in this period</h3>
                    </div>
                </div>
            </div>
        </div>
    `,
})
export class UptimeShowComponent implements OnInit {
    @Input() checkpoints: any;

    uptimeId: any;
    downtimes: any = 0;
    avgResponseTime: any = 0;
    avgResponseTimeClass: any = 0;
    uptime: any = [];
    lastresultReport: any = false;
    noResult: any = 0;
    date: any;
    dateFormat: any;
    downtimesList: any = [];
    sortedDownTimesList: any = [];
    datePickerOptions: any;
    exports: any;
    allScheduledDowntimes: any = 0;
    loading: any = false;
    promise: any;
    report: any = {};
    lineChartLabels: any = [];
    lineChartData: any = [];
    lineChartSeries: any;
    lineChartColors: any;
    lineChartOptions: any;
    overrideDatasets: any;
    successRateClass: any = '';

    constructor (
        private uptimeRepoService: UptimeRepoService,
        private stateService: StateService,
        private dateTimeService: DateTimeService,
        private translateService: TranslateService,
        private monEventService: MonEventService,
        private dateRangeService: DateRangeService,
        private monUIRouterTransitionService: MonUIRouterTransitionService,
        private activeRegionService: ActiveRegionService,
        private pipeService: PipeService,
    ) {}

    ngOnInit (): void {
        this.activate();
    }

    activate (): void {
        this.uptimeId = this.stateService.params.uptimeId;
        this.downtimes = 0;
        this.avgResponseTime = 0;
        this.uptime = [];
        this.lastresultReport = false;
        this.noResult = 0;
        this.date = this.dateRangeService.setRangeDates();
        this.dateFormat = DEFAULTS.DATE_FORMAT;
        this.downtimesList = [];
        this.sortedDownTimesList = [];
        this.setupDatePicker();
        this.setupLineChart();
        this.getUptime();
        this.getScheduledDowntimes();
        this.setExports();
    }

    setExports (): void {
        const startDate = this.dateTimeService.format(this.date.startDate._d, 'YYYY-MM-DD');
        const endDate = this.dateTimeService.format(this.date.endDate._d, 'YYYY-MM-DD');
        this.exports = [
            {
                tooltip: this.translateService.getString('Export list of downtimes for the domain'),
                name: this.translateService.getString('Uptime Monitoring Downtime'),
                data: {
                    category: 'heartbeat_downtime',
                    category_ref: startDate + ',' + endDate + ',' + this.uptimeId,
                },
            },
            {
                tooltip: this.translateService.getString('Export list of response times'),
                name: this.translateService.getString('Uptime Monitoring Response Time'),
                data: {
                    category: 'heartbeat_response_time',
                    category_ref: startDate + ',' + endDate + ',' + this.uptimeId,
                },
            },
        ];
    }

    getScheduledDowntimes (): void {
        const params = {
            page_size: 1,
            page: 1,
        };

        this.allScheduledDowntimes = 0;

        this.uptimeRepoService.getAllScheduledDowntimes(this.uptimeId, params).then((scheduledDowntimes: any) => {
            this.allScheduledDowntimes = parseInt(scheduledDowntimes.total, 10);
        }, () => {});
    }

    getUptime (): void {
        this.loading = true;

        let params: any = {
            start_date: this.date.startDate.format(),
            end_date: this.date.endDate.format(),
        };

        this.uptimeRepoService.get(this.uptimeId, undefined, contextTokens.NO_GLOBAL).then((uptime: any) => {
            this.uptime = uptime;
        }, () => {});

        this.promise = this.uptimeRepoService.getReport(this.uptimeId, params, contextTokens.NO_GLOBAL)
            .then((data: any) => {
                this.report = data;
                this.successRateClass = this.formatResponsetime(data.success_rate);
                this.downtimes = data.downtimes_count;
                this.avgResponseTimeClass = this.formatResponsetime(Math.round(data.avg_response_time));
                this.avgResponseTime = data.avg_response_time;
                this.lastresultReport = data.last_result;
            })
            .then(
                () => {
                    params = {
                        start_date: this.date.startDate.format(),
                        end_date: this.date.endDate.format(),
                        page_size: 0,
                    };

                    return this.uptimeRepoService.getDowntimes(this.uptimeId, params).then((downTimesData: any) => {
                        this.downtimesList = downTimesData;
                        this.sortedDownTimesList = this.downtimesList.sort((a: any, b: any) => {
                            const dateA = new Date(a.start_at);
                            const dateB = new Date(b.start_at);
                            if (dateA > dateB) {
                                return -1;
                            }
                            if (dateA < dateB) {
                                return 1;
                            }
                            return 0;
                        });
                        this.setupHeartBeat();
                        this.loading = false;
                    }, () => {});
                },
                () => {
                    this.monUIRouterTransitionService.onTransitionFinished(
                        () => {
                            this.stateService.go('base.customer.domain.uptimes.index');
                        },
                    );
                },
            );
    }

    setupHeartBeat (): void {
        this.lineChartLabels = [];
        this.lineChartData[0] = new Array(this.report.data.length);
        this.lineChartData[1] = [];
        this.lineChartData[2] = [];

        this.report.data.forEach((data: any) => {
            this.lineChartLabels.push(this.dateTimeService.formatBrowserLocalized(data.timestamp, 'MMM DD LT'));
            this.lineChartData[1].push(data.avg);
            this.lineChartData[2].push(this.avgResponseTime);
        });

        this.downtimesList.forEach((data: any) => {
            const startAt = this.dateTimeService.formatBrowserLocalized(this.dateTimeService.startOf(data.start_at, 'hour'), 'MMM DD LT');
            let downtimeIndex = this.lineChartLabels.findIndex((date: any) => date === startAt);
            if (downtimeIndex === -1) {
                downtimeIndex = this.lineChartLabels.findIndex((date: any) =>
                    this.dateTimeService.isAfter(this.dateTimeService.formatBrowserLocalized(date, 'MMM DD LT'), data.start_at),
                );
                if (downtimeIndex === -1) {
                    downtimeIndex = this.lineChartLabels.length;
                    this.lineChartLabels.push(startAt);
                    this.lineChartData[0].push(0);
                    this.lineChartData[1].push(0);
                    this.lineChartData[2].push(this.avgResponseTime);
                } else {
                    this.lineChartLabels.splice(downtimeIndex, 0, startAt);
                }
            }

            this.lineChartData[0][downtimeIndex] = this.dateTimeService.diff(data.end_at, data.start_at, 'minutes' as any) || 1;
        });
    }

    showCheckpointList (): void {
        const params = {
            body: IncidentListComponent,
            size: 'sm',
            data: {
                uptime: this.uptime,
                startDate: this.date.startDate.format(),
                endDate: this.date.endDate.format(),
            },
        };
        this.monEventService.run(MON_EVENTS.LOAD_DIALOG, { params });
    }

    openScheduleDowntime (): void {
        const params = {
            body: FormUptimeScheduledDowntimesComponent,
            size: 'md',
            data: { uptimeId: this.uptimeId },
        };

        this.monEventService.run(MON_EVENTS.LOAD_DIALOG, { params, callback: this.getScheduledDowntimes.bind(this) });
    }

    uptimeCreate (): void {
        const params = { body: UptimeComponent, data: { size: 'md' } };
        const callback = (uptime: any) => {
            if (typeof uptime === 'object' && uptime !== null) {
                this.monUIRouterTransitionService.onTransitionFinished(
                    () => {
                        this.stateService.go('base.customer.domain.uptimes.index');
                    },
                );
            }
        };

        this.monEventService.run(MON_EVENTS.LOAD_DIALOG, { params, callback });
    }

    duration (start: any, end: any): any {
        if (!end) {
            return this.dateTimeService.durationHumanized(undefined, start);
        }
        return this.dateTimeService.durationHumanized(end, start);
    }

    uptimeEdit (uptime: any): void {
        const params = { body: UptimeComponent, data: { uptime: uptime, size: 'md' } };

        this.monEventService.run(MON_EVENTS.LOAD_DIALOG, { params, callback: this.getUptime.bind(this) });
    }

    onDateChange (): void {
        this.getUptime();
        this.setExports();
    }

    setupLineChart (): void {
        this.lineChartSeries = [
            this.translateService.getString('Incidents'),
            this.translateService.getString('Response time'),
            this.translateService.getString('Avg. response'),
        ];
        this.lineChartLabels = [];
        this.lineChartColors = ['#e76468', '#249ff9', '#dc7ec7'];
        this.lineChartData = [];

        this.lineChartOptions = {
            scales: {
                xAxes: [
                    {
                        id: 'x-axis-0',
                        // type: "linear",
                        gridLines: {
                            offsetGridLines: true,
                            display: false,
                        },
                        ticks: {
                            autoSkip: false,
                            callback: (date: any, index: any) => {
                                const difference = Math.abs(this.date.endDate.diff(this.date.startDate, 'hour'));
                                const result = Math.ceil(difference / 90);
                                return index % result === 0 ? date : '';
                            },
                        },
                    },
                    {
                        id: 'x-axis-1',
                        barPercentage: 0.1,
                        categoryPercentage: 0.5,
                        barThickness: 1,
                        display: false,
                    },
                ],
                yAxes: [
                    {
                        id: 'y-axis-0',
                        scaleLabel: {
                            display: true,
                            labelString: this.translateService.getString('Response time (Milliseconds)'),
                            fontStyle: 500,
                        },
                        ticks: {
                            beginAtZero: true,
                            callback: (value: any) => this.pipeService.get('monNumber')(value, '0,0'),
                        },
                        gridLines: {
                            display: false,
                        },
                    },
                    {
                        id: 'y-axis-1',
                        position: 'right',
                        scaleLabel: {
                            display: true,
                            labelString: this.translateService.getString('Downtime (Minutes)'),
                            fontStyle: 500,
                        },
                        ticks: {
                            beginAtZero: true,
                            callback: (value: any, index: any, values: any) => {
                                const maxSteps = 10;
                                if (values.length < maxSteps) {
                                    return value;
                                }
                                const divider = (values.length - 1) / maxSteps || 0;
                                const indexes: any = [];
                                values.forEach((val: any, ind: any) => {
                                    if (ind === 0 || Math.round(indexes.length * divider) === ind) {
                                        indexes.push(ind);
                                    }
                                });

                                if (indexes.indexOf(index) > -1) {
                                    return this.pipeService.get('monNumber')(value, '0,0');
                                }
                            },
                            maxTicksLimit: 3,
                            stepSize: 10,
                        },
                    },
                ],
            },
            backgroundAreas: [
                {
                    range: [RESPONSE_TIME.SECONDS.OK.FROM, RESPONSE_TIME.SECONDS.OK.TO],
                    color: RESPONSE_TIME.SECONDS.OK.GRAPHCOLOR,
                },
                {
                    range: [RESPONSE_TIME.SECONDS.WARNING.FROM, RESPONSE_TIME.SECONDS.WARNING.TO],
                    color: RESPONSE_TIME.SECONDS.WARNING.GRAPHCOLOR,
                },
                {
                    range: [RESPONSE_TIME.SECONDS.ERROR.FROM, RESPONSE_TIME.SECONDS.ERROR.TO],
                    color: RESPONSE_TIME.SECONDS.ERROR.GRAPHCOLOR,
                },
            ],
            legend: {
                display: true,
                position: 'bottom',
                fullWidth: true,
                labels: {
                    boxWidth: 20,
                    padding: 20,
                },
            },
            tooltips: {
                intersect: false,
                callbacks: {
                    label: (item: any, data: any) => {
                        const dataset = data.datasets[item.datasetIndex];
                        const value = this.pipeService.get('monNumber')(dataset.data[item.index] || 0, '0,0');
                        if (this.lineChartSeries[0] === dataset.label) {
                            // Downtime label
                            return value + ' ' + this.translateService.getString('minutes');
                        } else {
                            // Response time label
                            return value + ' ' + this.translateService.getString('milliseconds');
                        }
                    },
                },
            },
        };

        this.overrideDatasets = [
            {
                type: 'bar',
                backgroundColor: this.lineChartColors[0],
                yAxisID: 'y-axis-1',
                xAxisID: 'x-axis-1',
            },
            {
                type: 'line',
                backgroundColor: this.lineChartColors[1],
                yAxisID: 'y-axis-0',
                xAxisID: 'x-axis-0',
                lineTension: 0,
                pointRadius: 0,
                pointHitRadius: 10,
                fill: false,
            },
            {
                type: 'line',
                backgroundColor: this.lineChartColors[2],
                yAxisID: 'y-axis-0',
                xAxisID: 'x-axis-0',
                lineTension: 0,
                pointRadius: 0,
                pointHitRadius: 10,
                fill: false,
            },
        ];

        for (let k = 0; k < this.lineChartSeries.length; k++) {
            this.lineChartData[k] = [];
        }
    }

    showApology (): boolean {
        return (
            this.activeRegionService.isInRegion('US') &&
            (this.dateTimeService.isBetween('2018-10-06', this.date.startDate, this.date.endDate, 'YYYY-MM-DD') ||
            this.dateTimeService.isBetween('2018-10-10', this.date.startDate, this.date.endDate, 'YYYY-MM-DD'))
        );
    }

    // PROTECTED

    setupDatePicker (): void {
        this.datePickerOptions = {
            maxDate: this.dateTimeService.toDate(undefined),
            ranges: {
                'Last Week': [this.dateTimeService.startOf(this.dateTimeService.subtract(new Date(), 7, 'days'), 'week'),
                    this.dateTimeService.endOf(this.dateTimeService.subtract(new Date(), 7, 'days'), 'week')],
                'Last Month': [this.dateTimeService.startOf(this.dateTimeService.subtract(new Date(), 1, 'month'), 'month'),
                    this.dateTimeService.endOf(this.dateTimeService.subtract(new Date(), 1, 'month'), 'month')],
                'Last Quarter': [this.dateTimeService.startOf(this.dateTimeService.subtract(new Date(), 1, 'quarter'), 'quarter'),
                    this.dateTimeService.endOf(this.dateTimeService.subtract(new Date(), 1, 'quarter'), 'quarter')],
                'Last Half Year': [
                    this.dateTimeService.startOf(this.dateTimeService.subtract(new Date(), 2, 'quarter'), 'quarter'),
                    this.dateTimeService.endOf(this.dateTimeService.subtract(new Date(), 1, 'quarter'), 'quarter'),
                ],
                'Last Year': [this.dateTimeService.startOf(this.dateTimeService.subtract(new Date(), 1, 'year'), 'year'),
                    this.dateTimeService.endOf(this.dateTimeService.subtract(new Date(), 1, 'year'), 'year')],
            },
        };
    }

    formatResponsetime (responsetime: any): any {
        if (parseFloat(responsetime) <= RESPONSE_TIME.SECONDS.OK.TO) {
            return RESPONSE_TIME.SECONDS.OK.COLORCLASS;
        }

        if (parseFloat(responsetime) <= RESPONSE_TIME.SECONDS.WARNING.TO) {
            return RESPONSE_TIME.SECONDS.WARNING.COLORCLASS;
        }
        return RESPONSE_TIME.SECONDS.ERROR.COLORCLASS;
    }

    formatResponsetimePercentage (responsetime: any): any {
        if (parseFloat(responsetime) >= RESPONSE_TIME.PERCENTAGE.OK.FROM) {
            return RESPONSE_TIME.PERCENTAGE.OK.COLORCLASS;
        }

        if (parseFloat(responsetime) >= RESPONSE_TIME.PERCENTAGE.WARNING.FROM) {
            return RESPONSE_TIME.PERCENTAGE.WARNING.COLORCLASS;
        }
        return RESPONSE_TIME.PERCENTAGE.ERROR.COLORCLASS;
    }
}
